(function () {
  const CHECKOUT_PATH = "/pages/qpay-checkout";
  const DEFAULT_BUY_NOW_PRODUCT_HANDLE = "nofaith-store-litter";
  const LABEL_TRANSLATIONS = [
    {
      from: /add\s+to\s+cart/gi,
      to: "Сагсанд нэмэх",
    },
    {
      from: /buy\s+it\s+now/gi,
      to: "Шууд захиалах",
    },
  ];
  const STOREFRONT_TRANSLATIONS = {
    "your cart": "Таны сагс",
    "continue shopping": "Худалдан авалтаа үргэлжлүүлэх",
    "product": "Бүтээгдэхүүн",
    "quantity": "Тоо ширхэг",
    "total": "Нийт",
    "order special instructions": "Захиалгын нэмэлт тайлбар",
    "estimated total": "Тооцоолсон нийт дүн",
    "taxes, discounts and shipping calculated at checkout.":
      "Татвар, хөнгөлөлт болон хүргэлтийн үнийг төлбөрийн үед тооцно.",
    "check out": "Төлбөр төлөх",
    "checkout": "Төлбөр төлөх",
    "contact": "Холбоо барих",
    "name": "Нэр",
    "email *": "И-мэйл *",
    "phone number": "Утасны дугаар",
    "comment": "Санал хүсэлт",
    "send": "Илгээх",
  };

  function buildCheckoutUrl(variantId, quantity) {
    const url = new URL(window.location.origin + CHECKOUT_PATH);

    if (variantId) {
      url.searchParams.set("add", variantId);
    }

    if (quantity) {
      url.searchParams.set("qty", quantity);
    }

    return url.pathname + url.search;
  }

  function getLocaleAwareUrl(path) {
    const rootPath =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    return rootPath + path.replace(/^\//, "");
  }

  function resolveProductForm(trigger) {
    if (!trigger) {
      return null;
    }

    const closestForm = trigger.closest('form[action*="/cart/add"]');

    if (closestForm) {
      return closestForm;
    }

    if (trigger.form && /\/cart\/add(?:\.js)?(?:\/|\?|#|$)/.test(trigger.form.getAttribute("action") || "")) {
      return trigger.form;
    }

    const formId = trigger.getAttribute("form");

    if (formId) {
      const linkedForm = document.getElementById(formId);

      if (linkedForm && /\/cart\/add(?:\.js)?(?:\/|\?|#|$)/.test(linkedForm.getAttribute("action") || "")) {
        return linkedForm;
      }
    }

    const productContainer = trigger.closest(
        [
          "product-form",
          "product-info",
          ".product",
          ".product-form",
          ".product__info-container",
          '[id^="ProductInfo-"]',
          '[data-section-type*="product" i]',
          '[data-section*="product" i]',
        ].join(",")
    );

    if (productContainer) {
      const containerForm = productContainer.querySelector('form[action*="/cart/add"]');

      if (containerForm) {
        return containerForm;
      }
    }

    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    return productForms.length === 1 ? productForms[0] : null;
  }

  function resolveVariantId(trigger) {
    const explicit = trigger.getAttribute("data-variant-id");

    if (explicit) {
      return explicit;
    }

    const form = resolveProductForm(trigger);
    const input = form ? form.querySelector('[name="id"]') : null;

    if (input && input.value) {
      return input.value;
    }

    const section = trigger.closest("[data-section], section, main") || document;
    const fallback = section.querySelector('[name="id"], [data-variant-id], [data-product-variant-id]');

    if (!fallback) {
      return "";
    }

    return fallback.value || fallback.getAttribute("data-variant-id") || fallback.getAttribute("data-product-variant-id") || "";
  }

  function normalizeVariantId(value) {
    const normalized = String(value || "").trim();
    const gidMatch = /ProductVariant\/(\d+)$/.exec(normalized);

    return gidMatch ? gidMatch[1] : normalized;
  }

  function getVariantIdFromUrl(value) {
    if (!value) {
      return "";
    }

    try {
      const url = new URL(value, window.location.origin);
      return normalizeVariantId(url.searchParams.get("variant") || url.searchParams.get("add"));
    } catch (_error) {
      return "";
    }
  }

  function getProductHandleFromUrl(value) {
    if (!value) {
      return "";
    }

    try {
      const url = new URL(value, window.location.origin);
      const match = /\/products\/([^/?#]+)/.exec(url.pathname);
      return match ? decodeURIComponent(match[1]) : "";
    } catch (_error) {
      return "";
    }
  }

  function resolveProductHandle(trigger) {
    const explicit =
      trigger.getAttribute("data-product-handle") ||
      trigger.getAttribute("data-handle") ||
      "";

    if (explicit) {
      return explicit;
    }

    const directUrls = [
      trigger.getAttribute("data-product-url"),
      trigger.getAttribute("href"),
      window.location.pathname,
    ];

    for (let index = 0; index < directUrls.length; index += 1) {
      const handle = getProductHandleFromUrl(directUrls[index]);

      if (handle) {
        return handle;
      }
    }

    const section = trigger.closest("[data-section-id], .shopify-section, section");
    const scopes = section ? [section, document] : [document];

    for (let index = 0; index < scopes.length; index += 1) {
      const handles = new Set();

      scopes[index].querySelectorAll('a[href*="/products/"]').forEach(function (link) {
        const handle = getProductHandleFromUrl(link.getAttribute("href"));

        if (handle) {
          handles.add(handle);
        }
      });

      if (handles.size === 1) {
        return Array.from(handles)[0];
      }
    }

    return "";
  }

  async function fetchVariantIdByHandle(handle) {
    if (!handle) {
      return "";
    }

    const response = await fetch(
      getLocaleAwareUrl("/products/" + encodeURIComponent(handle) + ".js"),
      {
        headers: {
          Accept: "application/json",
        },
      }
    );

    if (!response.ok) {
      return "";
    }

    const product = await response.json();
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const selected = variants.find(function (variant) {
      return variant.available;
    }) || variants[0];

    return selected ? normalizeVariantId(selected.id) : "";
  }

  async function fetchOnlyAvailableStoreVariantId() {
    const response = await fetch(getLocaleAwareUrl("/products.json?limit=2"), {
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      return "";
    }

    const payload = await response.json();
    const products = Array.isArray(payload.products) ? payload.products : [];
    const availableProducts = products.filter(function (product) {
      return Array.isArray(product.variants) && product.variants.some(function (variant) {
        return variant.available;
      });
    });

    if (availableProducts.length !== 1) {
      return "";
    }

    const variant = availableProducts[0].variants.find(function (item) {
      return item.available;
    });

    return variant ? normalizeVariantId(variant.id) : "";
  }

  async function resolveVariantIdForBuyNow(trigger) {
    const directVariantId =
      normalizeVariantId(resolveVariantId(trigger)) ||
      getVariantIdFromUrl(trigger.getAttribute("href")) ||
      getVariantIdFromUrl(trigger.getAttribute("data-product-url"));

    if (directVariantId) {
      return directVariantId;
    }

    const handle = resolveProductHandle(trigger) || DEFAULT_BUY_NOW_PRODUCT_HANDLE;
    const handleVariantId = await fetchVariantIdByHandle(handle);

    if (handleVariantId) {
      return handleVariantId;
    }

    return fetchOnlyAvailableStoreVariantId();
  }

  function resolveQuantity(trigger) {
    const explicit = trigger.getAttribute("data-quantity");

    if (explicit) {
      return explicit;
    }

    const form = resolveProductForm(trigger);
    const input = form ? form.querySelector('[name="quantity"]') : null;
    return input ? input.value : "1";
  }

  function extractPropertyKey(name) {
    const match = /^properties\[(.+)\]$/.exec(name || "");
    return match ? match[1] : "";
  }

  function isUploadRelatedName(value) {
    return /upload|file|image|photo|poster|original|zurag/i.test(value || "");
  }

  function isLikelyFileUrl(value) {
    return (
      typeof value === "string" &&
      /^https?:\/\//i.test(value) &&
      /\.(jpg|jpeg|png|webp|gif|heic|pdf|svg|zip)(?:\?|#|$)/i.test(value)
    );
  }

  function collectUploadPropertyFallbacks(form) {
    const container =
      form.closest("product-form-component") ||
      form.closest("[data-product-root]") ||
      form.closest(".product") ||
      form.closest("main") ||
      document;
    const fileNames = new Set();
    const fileUrls = new Set();

    container.querySelectorAll('input[type="file"]').forEach(function (input) {
      Array.from(input.files || []).forEach(function (file) {
        if (file && file.name) {
          fileNames.add(file.name);
        }
      });
    });

    container
      .querySelectorAll('input[type="hidden"], input[type="text"], a[href], [data-file-name], [data-upload-name], [data-upload-url], [data-file-url]')
      .forEach(function (node) {
        const nodeName =
          node.getAttribute("name") ||
          node.getAttribute("id") ||
          node.getAttribute("class") ||
          node.getAttribute("data-file-name") ||
          node.getAttribute("data-upload-name") ||
          node.getAttribute("data-upload-url") ||
          node.getAttribute("data-file-url") ||
          "";
        const value =
          node.value ||
          node.getAttribute("href") ||
          node.getAttribute("data-file-name") ||
          node.getAttribute("data-upload-name") ||
          node.getAttribute("data-upload-url") ||
          node.getAttribute("data-file-url") ||
          node.textContent ||
          "";

        if (!String(value || "").trim()) {
          return;
        }

        if (isLikelyFileUrl(value)) {
          fileUrls.add(String(value).trim());

          const parts = String(value).split("/").filter(Boolean);
          const lastPart = parts[parts.length - 1];

          if (lastPart) {
            fileNames.add(decodeURIComponent(lastPart.split("?")[0]));
          }

          return;
        }

        if (!isUploadRelatedName(nodeName)) {
          return;
        }

        const trimmed = String(value).trim();

        if (/\.(jpg|jpeg|png|webp|gif|heic|pdf|svg|zip)$/i.test(trimmed)) {
          fileNames.add(trimmed.split(/[\\/]/).pop());
        }
      });

    const properties = {};

    if (fileNames.size > 0) {
      const list = Array.from(fileNames);
      properties.upload_file_names = list.join(", ");
      properties.upload_file_name = list[0];
    }

    if (fileUrls.size > 0) {
      const list = Array.from(fileUrls);
      properties.upload_file_urls = list.join(", ");
      properties.upload_file_url = list[0];
    }

    if (fileNames.size > 0 || fileUrls.size > 0) {
      properties.upload_bridge_source = "theme-qpay-entry";
    }

    return properties;
  }

  function buildCartAddPayload(form, trigger, resolvedVariantId) {
    const variantId = resolvedVariantId || resolveVariantId(trigger);
    const quantity = Number(resolveQuantity(trigger) || "1");
    const properties = {};
    const formData = form ? new FormData(form) : null;

    if (formData) {
      formData.forEach(function (value, key) {
        const propertyKey = extractPropertyKey(key);

        if (!propertyKey) {
          return;
        }

        const stringValue = typeof value === "string" ? value.trim() : "";

        if (stringValue) {
          properties[propertyKey] = stringValue;
        }
      });
    }

    const fallbackProperties = form ? collectUploadPropertyFallbacks(form) : {};

    Object.keys(fallbackProperties).forEach(function (key) {
      if (!properties[key] && fallbackProperties[key]) {
        properties[key] = fallbackProperties[key];
      }
    });

    return {
      items: [
        {
          id: Number(variantId),
          quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
          properties: properties
        }
      ]
    };
  }

  async function addProductToCartForQPay(trigger, resolvedVariantId) {
    const form = resolveProductForm(trigger);
    const variantId = normalizeVariantId(resolvedVariantId || resolveVariantId(trigger));

    if (!variantId) {
      throw new Error(
        "Захиалах бүтээгдэхүүн олдсонгүй. Товчинд product link эсвэл data-product-handle тохируулна уу."
      );
    }

    const payload = buildCartAddPayload(form, trigger, variantId);
    const response = await fetch(getLocaleAwareUrl("/cart/add.js"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      let message = "Cart add failed";

      try {
        const errorPayload = await response.json();
        message = errorPayload.description || errorPayload.message || message;
      } catch (_jsonError) {
        message = await response.text();
      }

      throw new Error(message);
    }
  }

  function goToQPayCheckout() {
    window.location.href = CHECKOUT_PATH;
  }

  async function redirectProductToQPay(trigger) {
    trigger.setAttribute("aria-busy", "true");

    if ("disabled" in trigger) {
      trigger.disabled = true;
    }

    try {
      const variantId = await resolveVariantIdForBuyNow(trigger);
      await addProductToCartForQPay(trigger, variantId);
      goToQPayCheckout();
    } catch (error) {
      console.error("[qpay-entry] Failed to prepare product for QPay checkout", error);
      trigger.removeAttribute("aria-busy");

      if ("disabled" in trigger) {
        trigger.disabled = false;
      }
    }
  }

  function hasCheckoutPath(value) {
    if (!value) {
      return false;
    }

    try {
      return new URL(value, window.location.origin).pathname.replace(/\/$/, "") === "/checkout";
    } catch (error) {
      return /\/checkout(?:\/|\?|#|$)/.test(value);
    }
  }

  function isCartContext(trigger) {
    return Boolean(
        trigger &&
        trigger.closest(
            [
              "cart-drawer",
              "cart-items-component",
              ".cart",
              ".cart-drawer",
              ".drawer",
              ".cart__ctas",
              ".cart__footer",
              ".cart-summary",
              '[id*="cart" i]',
              '[class*="cart" i]',
            ].join(",")
        )
    );
  }

  function getElementLabel(trigger) {
    if (!trigger) {
      return "";
    }

    return [
      trigger.textContent || "",
      trigger.getAttribute("value") || "",
      trigger.getAttribute("aria-label") || "",
      trigger.getAttribute("data-testid") || "",
    ]
        .join(" ")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
  }

  function translateValue(value) {
    if (!value) {
      return value;
    }

    return LABEL_TRANSLATIONS.reduce(function (text, translation) {
      return text.replace(translation.from, translation.to);
    }, value);
  }

  function translateExactValue(value) {
    const original = String(value || "");
    const trimmed = original.replace(/\s+/g, " ").trim();
    const translated = STOREFRONT_TRANSLATIONS[trimmed.toLowerCase()];

    if (!translated) {
      return original;
    }

    return original.replace(original.trim(), translated);
  }

  function translateStorefrontElement(element) {
    if (!(element instanceof Element)) {
      return;
    }

    if (element.matches("script, style, noscript, template")) {
      return;
    }

    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        const parent = node.parentElement;

        if (!parent || parent.matches("script, style, noscript, template")) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      },
    });
    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach(function (node) {
      const translated = translateExactValue(node.nodeValue);

      if (translated !== node.nodeValue) {
        node.nodeValue = translated;
      }
    });

    const translatableElements = [element].concat(
      Array.from(element.querySelectorAll("[placeholder], [aria-label], [title], input[value]"))
    );

    translatableElements.forEach(function (node) {
      ["placeholder", "aria-label", "title", "value"].forEach(function (attribute) {
        if (!node.hasAttribute(attribute)) {
          return;
        }

        const value = node.getAttribute(attribute);
        const translated = translateExactValue(value);

        if (translated !== value) {
          node.setAttribute(attribute, translated);
        }
      });
    });
  }

  function translateElementText(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach(function (node) {
      const translated = translateValue(node.nodeValue || "");

      if (translated !== node.nodeValue) {
        node.nodeValue = translated;
      }
    });

    ["aria-label", "title", "value"].forEach(function (attribute) {
      if (!element.hasAttribute(attribute)) {
        return;
      }

      const value = element.getAttribute(attribute);
      const translated = translateValue(value);

      if (translated !== value) {
        element.setAttribute(attribute, translated);
      }
    });
  }

  function translateProductButtonLabels(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const selector = [
      'form[action*="/cart/add"] button',
      'form[action*="/cart/add"] input[type="submit"]',
      ".shopify-payment-button__button",
      ".shopify-payment-button button",
      "button[name='add']",
      "[data-add-to-cart]",
      "[data-testid*='buy' i]",
      "[aria-label*='buy it now' i]",
    ].join(",");

    if (scope instanceof Element && scope.matches(selector)) {
      translateElementText(scope);
    }

    scope.querySelectorAll(selector).forEach(translateElementText);
  }

  function hasCheckoutLabel(trigger) {
    const label = getElementLabel(trigger);

    return [
      "checkout",
      "check out",
      "төлбөр төлөх",
      "захиалга баталгаажуулах",
    ].some(function (text) {
      return label.includes(text);
    });
  }

  function isBuyNowButton(trigger) {
    if (!trigger) {
      return false;
    }

    const label = getElementLabel(trigger);

    return (
        trigger.matches(".shopify-payment-button__button, .shopify-payment-button button") ||
        trigger.closest(".shopify-payment-button") ||
        label.includes("buy it now") ||
        label.includes("шууд худалдаж авах") ||
        label.includes("шууд захиалах")
    );
  }

  function isCheckoutLink(trigger) {
    if (!trigger || trigger.tagName !== "A") {
      return false;
    }

    const href = trigger.getAttribute("href") || "";
    return hasCheckoutPath(href) || (isCartContext(trigger) && hasCheckoutLabel(trigger));
  }

  function isCheckoutButton(trigger) {
    if (!trigger) {
      return false;
    }

    const name = (trigger.getAttribute("name") || "").toLowerCase();
    const id = (trigger.getAttribute("id") || "").toLowerCase();
    const type = (trigger.getAttribute("type") || "").toLowerCase();
    const form = trigger.closest("form");
    const formAction = form ? form.getAttribute("action") || "" : "";

    return (
        name === "checkout" ||
        id === "checkout" ||
        trigger.hasAttribute("data-checkout-button") ||
        trigger.matches(".cart__checkout-button, [data-cart-checkout], .wt-cart__cta, .cart__checkout") ||
        (type === "submit" && /\/cart(?:\/|\?|#|$)/.test(formAction) && hasCheckoutLabel(trigger)) ||
        (isCartContext(trigger) && hasCheckoutLabel(trigger))
    );
  }

  function getTriggerSelector() {
    return [
      "[data-qpay-redirect]",
      ".shopify-payment-button__button",
      ".shopify-payment-button button",
      "a",
      "button",
      "input[type='submit']",
      "[role='button']",
      "[data-testid*='checkout' i]",
      "[data-testid*='buy' i]",
      "[aria-label*='buy it now' i]",
      "[class*='checkout' i]",
      "[class*='continue' i]",
      ".wt-cart__cta",
      ".cart__checkout",
    ].join(",");
  }

  function resolveCheckoutTriggerFromNode(node) {
    if (!(node instanceof Element)) {
      return null;
    }

    return node.closest(getTriggerSelector());
  }

  function resolveCheckoutTrigger(event) {
    const path = typeof event.composedPath === "function" ? event.composedPath() : [];

    for (let index = 0; index < path.length; index += 1) {
      const trigger = resolveCheckoutTriggerFromNode(path[index]);

      if (trigger) {
        return trigger;
      }
    }

    return resolveCheckoutTriggerFromNode(event.target);
  }

  function stopNativeCheckout(event) {
    event.preventDefault();

    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    } else {
      event.stopPropagation();
    }
  }

  function handleCheckoutIntent(event) {
    const trigger = resolveCheckoutTrigger(event);

    if (!trigger) {
      return;
    }

    if (isBuyNowButton(trigger)) {
      stopNativeCheckout(event);

      if (trigger.getAttribute("aria-busy") === "true") {
        return;
      }

      redirectProductToQPay(trigger);
      return;
    }

    if (isCheckoutLink(trigger) || isCheckoutButton(trigger)) {
      stopNativeCheckout(event);
      goToQPayCheckout();
      return;
    }

    if (!trigger.matches("[data-qpay-redirect]")) {
      return;
    }

    stopNativeCheckout(event);

    if (trigger.getAttribute("aria-busy") === "true") {
      return;
    }

    redirectProductToQPay(trigger);
  }

  document.addEventListener("click", handleCheckoutIntent, true);

  document.addEventListener("submit", function (event) {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    const action = form.getAttribute("action") || "";
    const submitter = event.submitter instanceof Element ? event.submitter : null;
    const isCheckoutSubmit = submitter ? isCheckoutButton(submitter) : Boolean(form.querySelector('[name="checkout"]'));

    if (/\/cart(?:\/|\?|#|$)/.test(action) && isCheckoutSubmit) {
      stopNativeCheckout(event);
      goToQPayCheckout();
    }
  }, true);

  document.addEventListener(
      "touchend",
      handleCheckoutIntent,
      { passive: false, capture: true }
  );

  document.addEventListener(
      "pointerup",
      handleCheckoutIntent,
      true
  );

  translateProductButtonLabels(document);
  translateStorefrontElement(document.documentElement);

  document.addEventListener("DOMContentLoaded", function () {
    translateProductButtonLabels(document);
    translateStorefrontElement(document.documentElement);
  });

  if ("MutationObserver" in window) {
    const labelObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node instanceof Element) {
            translateProductButtonLabels(node);
            translateStorefrontElement(node);
          }
        });
      });
    });

    labelObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
